import React, { FC, useState } from "react";
import { RouterParamType } from "@/model/navModel";
import { FormBox } from "./FormBox";


export const BaseDetail: FC<RouterParamType> = (detailsInfo) => {

    return (
        <>
            <FormBox {...detailsInfo} />
        </>

    )
}